import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "GridFood",
  uniqId: "grid_food",
})((theme, { params }, classes) => {
  return {
    ContentFood: {
      fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
      fontWeight: "500",
      fontSize: "18px",
      lineHeight: "36px",
      letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
      color: "#333",
      paddingTop: "20px",
      textAlign: "center",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": "2",
      "-webkit-box-orient": "vertical",
      [theme.breakpoints.down("md")]: {
        fontSize: "16px",
        "-webkit-line-clamp": 1,
        display: "block",
        overflowWrap: "break-word",
        height: "50px",
      },
    },
    imgGridFood: {
      margin: "auto",
    },
  };
});

export default useStyles;
